export function parseCookieValue(cookieHeader: string, name: string): string {
  const prefix = `${name}=`;
  const match = cookieHeader.split('; ').find((row) => row.startsWith(prefix));
  return match ? decodeURIComponent(match.slice(prefix.length)) : '';
}

/**
 * Read a cookie by name. Browser-only — returns '' on the server.
 */
export function readCookie(name: string): string {
  if (typeof document === 'undefined') {
    return '';
  }

  return parseCookieValue(document.cookie, name);
}
